// extracted by mini-css-extract-plugin
export default {"pageHolder":"CreatePublicDiscountCodeContainer_pageHolder__-+igd"};